<template>
  <div id="imgcontainer">
    <div id="image" v-if="enableDownload">
      <div v-if="productsData && productsData.length > 0">
        <div v-bind:key="'each-product'+mainIndex" v-for="(eachProduct, mainIndex) in productsData">
          <template v-if="eachProduct.variants && eachProduct.variants.length > 0">
            <div style="width:900px; height:1425px" :id="'product_card_'+mainIndex+childIndex"  v-bind:key="'pdf-qr-card'+variant.id" v-for="(variant,childIndex) in eachProduct.variants">
               <CustomQrUiImageVariant :customStyle="'custom-size'" :pdftype="'image'" :variant="variant" :product="eachProduct" :qrCodeValue="qrCodeUrl(eachProduct)" :isPdf="true" />
            </div>
          </template>
        </div>
      </div>
      <!-- <product-qr-ui
        :product="product"
        :qrCodeValue="qrCodeValue"
        :borders="false"
        :isPdf="true"
      /> -->
    </div>
  </div>
</template>
<script>
import * as htmlToImage from 'html-to-image'
import ProductQrUi from '@/components/app-specific/ProductQrUi.vue'
import ProductQrUiVariant from '@/components/app-specific/ProductQrUiVariant.vue'
import CustomQrUiImageVariant from '@/components/app-specific/CustomQrUiImageVariant.vue'
import { mapGetters } from 'vuex'
import { changeDpiDataUrl } from 'changedpi'
export default {
  components: {
    ProductQrUi,
    ProductQrUiVariant,
    CustomQrUiImageVariant
  },
  props: ['productsData', 'enableDownload'],
  data() {
    return {
      product: {},
      qrCodeValue: '',
      index: 0
    }
  },
  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected',
      vg_selectedBusiness: 'auth/activeBusiness'
    })
  },
  methods: {
    getQrCodeValue(item) {
      this.qrCodeValue =
        process.env.VUE_APP_PRODUCT_QR_URL +
        '/' +
        this.vg_selectedBusiness.slug +
        '/' +
        this.vg_selectedLocation.slug +
        '/' +
        item.id +
        '?in_store=true&noage=true'
        //return this.qrCodeValue;
    },

    qrCodeUrl(item) {
      return process.env.VUE_APP_PRODUCT_QR_URL +
        '/' +
        this.vg_selectedBusiness.slug +
        '/' +
        this.vg_selectedLocation.slug +
        '/' +
        item.id +
        '?in_store=true&noage=true'
    },
    async downloadingStart() {
      if (this.index === this.productsData.length) {
        this.$emit('disable')
        return;
      }
      let item = this.productsData[this.index]
      this.product = item
      this.getQrCodeValue(item)
      await htmlToImage
        .toJpeg(document.getElementById('image'))
        .then(function(dataUrl) {
          const downloadLink = document.createElement('a')
          downloadLink.href = changeDpiDataUrl(dataUrl, 300)
          downloadLink.download = 'image.jpeg'
          downloadLink.click()
        }).catch((err) => {
          console.log(err)
        })
      this.index = this.index + 1;
      this.downloadingStart()
    },
    /**
     * Download images
     */
    async downloadImages() {
      for (let mainI = 0; mainI < this.productsData.length; mainI++) {
        let product = this.productsData[mainI];
        for (let i = 0; i < product.variants.length; i++) {
          let image = document.getElementById('product_card_' + mainI + i)
          let fileName = product.name ? product.name + (product.variants[i].size ? '-' + product.variants[i].size : '') + '.jpeg' : 'image.jpeg';
          await htmlToImage.toJpeg(image, {
            backgroundColor: '#FFFFFF',
            quality: 1,
            pixelRatio: 1,
            width: 900,
            height: 1425
          })
            .then(function(dataUrl) {
                const downloadLink = document.createElement('a');
                downloadLink.href = changeDpiDataUrl(dataUrl, 300);
                downloadLink.download = fileName;
                downloadLink.click();
            })
        }
      }
      console.log('ends')
      this.$emit('disable')
    }
  },
  watch: {
    enableDownload: async function(value) {
      // debugger
      if (value) {
        setTimeout(() => {
          this.index = 0
          this.downloadImages()
        }, 500)
      }
    }
  }
}
</script>
<style lang="scss">
#image {
  height: fit-content;
  width: fit-content;
}
</style>
